<template>
    <div v-if="historyList.length != 0">
         <!-- 历史记录 -->
        <div v-show="historyFlag">
            <div class="history" v-for="item in historyList" :key="item.id">
                <div class="form-item">
                    <div class="item-title">申请理由：</div>
                    <div class="item-text">{{ item[0].reason }}</div>
                </div>
                <div class="form-item" v-if="item && item.length == 2 ">
                    <div class="item-title">审核说明：</div>
                    <div class="item-text">{{ item[1].reason }}</div>
                </div>
            </div>
        </div>
        <div class="history-func" @click="historyFlag = !historyFlag">{{ historyFlag?"-- 收起历史记录 --":"-- 更多历史记录 --" }}</div>
    </div>
</template>

<script>
    export default {
        props:["data","listdata"],
        data(){
            return {
                historyFlag:false,
                // newestLog:[],
            }
        },
        computed:{
            historyList(){
                if(this.listdata){
                    return this.listdata.slice(1);
                }

                let req = this.data;
                let arr = [];
                let count = [];

                for(let i in req){
                    count.push(req[i]);
                    if(count.length == 2){
                        arr.unshift(count);
                        count = [];
                    }
                }
                // 不为0 自动过滤
                if(count.length == 0){
                    arr.shift();
                }
                return arr;
            },
        },
        watch:{
            data(val){
                if(!val){
                    this.historyFlag = false;
                }
            },
        },

    }
</script>

<style lang="less" scoped>
    .history{
        border-top: 2px dashed #e2e2e2;
        padding-top: 20px;
    }
    .history-func{
        text-align: center;
        color: #20a0ff;
        cursor: pointer;
    }
</style>





// WEBPACK FOOTER //
// slider_history.vue?05f0a5fe